<template>
    <div class="wrapper stock">
        <table class="custom-table">
            <thead>
                <tr>
                    <td class="custom-th custom-th-bg" style="min-width:60px;">
                        序号
                    </td>
                    <td class="custom-th custom-th-bg" style="min-width:100px;">
                        品种
                    </td>
                    <td class="custom-th custom-th-bg" style="min-width:180px;">
                        项目
                    </td>
                    <template v-for="(item, index) in StockData[0].stockTypes">
                        <td class="custom-th custom-th-bg mongth-th" :key="'th'+index" v-if="item.date>0">
                            {{ item.date }}月
                        </td>
                        <td class="custom-th custom-th-bg mongth-th" :key="'th'+index" v-if="item.date==0">
                            总计
                        </td>
                    </template>
                </tr>
            </thead>
            <tbody>
                <template v-for="(item, index) in StockData">
                    <tr :key="index">
                        <td
                            class="custom-th"
                            :rowspan="item.stockTypeReportDetails.length + 1"
                            :class="{'custom-th-odd':index%2===0,'custom-th-even':index%2===1, 'border6':index<StockData.length-1}"
                            style="min-width:60px;"
                        >
                            {{ index+1 }}
                        </td>
                        <td class="custom-th" :class="{'border6':item.stockTypeReportDetails.length<=0&&index<StockData.length-1}">
                            {{ item.label }}
                        </td>
                        <td :class="{'border6':item.stockTypeReportDetails.length<=0&&index<StockData.length-1}">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>库存减少（吨）</th>
                                    </tr>
                                    <tr>
                                        <th>期初库存（吨）</th>
                                    </tr>
                                    <tr>
                                        <th>期末库存（吨）</th>
                                    </tr>
                                    <tr>
                                        <th>核定库存（吨）</th>
                                    </tr>
                                    <tr>
                                        <th>占压资金减少（元）</th>
                                    </tr>
                                    <tr>
                                        <th>期初占压资金（元）</th>
                                    </tr>
                                    <tr>
                                        <th>期末占压资金（元）</th>
                                    </tr>
                                    <tr>
                                        <th>核定占压资金（元）</th>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <template v-for="(k, i) in item.stockTypes">
                            <td :key="i" :class="{'border6':item.stockTypeReportDetails.length<=0&&index<StockData.length-1}">
                                <table v-if="isDrill">
                                    <tbody>
                                        <tr>
                                            <td @click="showDataDrills(k,1,0)">
                                                <a href="javascript:;">{{ k.stock_reduce }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,2,0)">
                                                <a href="javascript:;">{{ k.stock_begin }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,3,0)">
                                                <a href="javascript:;">{{ k.stock_end }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,4,0)">
                                                <a href="javascript:;">{{ k.stock_auth }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,5,0)">
                                                <a href="javascript:;">{{ k.fund_reduce }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,6,0)">
                                                <a href="javascript:;">{{ k.fund_begin }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,7,0)">
                                                <a href="javascript:;">{{ k.fund_end }}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td @click="showDataDrills(k,8,0)">
                                                <a href="javascript:;">{{ k.fund_auth }}</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table v-else>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {{ k.stock_reduce }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.stock_begin }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.stock_end }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.stock_auth }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.fund_reduce }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.fund_begin }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.fund_end }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ k.fund_auth }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </template>
                    </tr>
                    <template v-for="(j, a) in item.stockTypeReportDetails">
                        <tr :key="j.label + a" :class="{'border6': a===item.stockTypeReportDetails.length-1}">
                            <td class="custom-th">
                                {{ j.label }}
                            </td>
                            <td>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>库存减少（吨）</th>
                                        </tr>
                                        <tr>
                                            <th>期初库存（吨）</th>
                                        </tr>
                                        <tr>
                                            <th>期末库存（吨）</th>
                                        </tr>
                                        <tr>
                                            <th>核定库存（吨）</th>
                                        </tr>
                                        <tr>
                                            <th>占压资金减少（元）</th>
                                        </tr>
                                        <tr>
                                            <th>期初占压资金（元）</th>
                                        </tr>
                                        <tr>
                                            <th>期末占压资金（元）</th>
                                        </tr>
                                        <tr>
                                            <th>核定占压资金（元）</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <template v-for="(b, c) in j.stockTypeDetails">
                                <td :key="c">
                                    <table v-if="isDrill">
                                        <tbody>
                                            <tr>
                                                <td @click="showDataDrills(b,1,1)">
                                                    <a href="javascript:;">{{ b.stock_reduce }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,2,1)">
                                                    <a href="javascript:;">{{ b.stock_begin }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,3,1)">
                                                    <a href="javascript:;">{{ b.stock_end }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,4,1)">
                                                    <a href="javascript:;">{{ b.stock_auth }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,5,1)">
                                                    <a href="javascript:;">{{ b.fund_reduce }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,6,1)">
                                                    <a href="javascript:;">{{ b.fund_begin }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,7,1)">
                                                    <a href="javascript:;">{{ b.fund_end }}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td @click="showDataDrills(b,8,1)">
                                                    <a href="javascript:;">{{ b.fund_auth }}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table v-else>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {{ b.stock_reduce }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.stock_begin }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.stock_end }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.stock_auth }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.fund_reduce }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.fund_begin }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.fund_end }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{ b.fund_auth }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    // 库存情况
    name: 'stock',
    components: {},
    props: {
        loadObj: {
            type: [Object],
        },
        queryStr: {
            type: [String],
        },
        reportData: {
            type: [Object],
        },
    },
    data() {
        return {
            // 库存情况数据集合
            StockData: [
                { label: '', stockTypes: [], stockTypeReportDetails: [] },
            ],
            isDrill: true,
        };
    },
    watch: {
        queryStr: function () {
            this.gitStockData();
        },
    },
    computed: {},
    methods: {
        // 获取物质采购数据
        gitStockData() {
            this.$axios
                .get('/interfaceApi/report/stock/report/' + this.queryStr)
                .then(res => {
                    this.StockData = res;
                    // this.loadObj.close();
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 数据钻取
        // eslint-disable-next-line max-params
        showDataDrills(rowData, filed, datatype) {
            let parseField = 0;
            let parsetText = null;
            let showType = null;
            const openType = null;
            switch (filed) {
                case 1:
                    parseField = 1;
                    parsetText = '库存减少（吨）';
                    // openType = 'pop2';
                    showType = 1;
                    break;
                case 2:
                    parseField = 2;
                    parsetText = '期初库存（吨）';
                    showType = 1;
                    break;
                case 3:
                    parseField = 3;
                    parsetText = '期末库存（吨）';
                    showType = 1;
                    break;
                case 4:
                    parseField = 4;
                    parsetText = '核定库存（吨）';
                    break;
                case 5:
                    parseField = 5;
                    parsetText = '占压资金减少（元）';
                    break;
                case 6:
                    parseField = 6;
                    parsetText = '期初占压资金（元）';
                    break;
                case 7:
                    parseField = 7;
                    parsetText = '期末占压资金（元）';
                    break;
                case 8:
                    parseField = 8;
                    parsetText = '核定占压资金（元）';
                    break;
                default:
                    parseField = 0;
            }
            let istotal = 0;
            let month = 0;
            if (rowData.date === 0) {
                istotal = 1;
                if (this.reportData.month === 0) {
                    month = 12;
                } else {
                    month = this.reportData.month;
                }
            } else {
                istotal = 0;
                month = rowData.date;
            }
            let type = null;
            let name = null;
            if (datatype === 0) {
                type = rowData.type_code;
                name = rowData.type_name;
            } else {
                type = rowData.stock_type;
                name = rowData.type_code;
            }

            let t_url = 'reportManage/operationTrends/summary/dataDrills/DrillDownPop';
            if (!openType) {
                t_url = 'reportManage/operationTrends/summary/dataDrills/DrillDownPop';
            }
            const params = {
                field: parseField,
                text: parsetText,
                year: this.reportData.year,
                month: month,
                business_code: 'yyqk',
                istotal: istotal,
                treeid: this.reportData.treeid,
                type: type,
                name: name,
                firstPop: true,
                sourceReport: 'stock',
                datatype: datatype,
                showType: showType,
            };
            const pop = this.$toast({
                title: false,
                t_url: t_url,
                type: 'eject',
                width: '80%',
                extr: { closeBtn: { width: '.600px', height: '.600px', 'line-height': '.600px' }, params: params },
            });
            window.window.$globalHub.$store.commit('setChartPop', pop);

        },
        isDrillFn() {
            if (this.reportData.org_type === 5 || this.reportData.org_type === 6) {
                this.isDrill = false;
            } else {
                this.isDrill = true;
            }
        },
    },
    created() {
        this.gitStockData();
    },
    mounted() {
        this.isDrillFn();
    },
};
</script>
<style lang="stylus">
.stock
    table
        table
            width 100%
            height 100%
            border-collapse collapse
            table-layout fixed
            word-break break-all
            tr
                &:last-child
                    th
                        border none !important
                    td
                        border none !important
                th
                    border none !important
                    border-bottom 1px solid #ebeef5 !important
                    font-weight 400
                    line-height initial !important
                    &:nth-of-type(1)
                        border-right 1px solid #ebeef5 !important
                td
                    border none !important
                    border-bottom 1px solid #ebeef5 !important
                    line-height initial !important
</style>